module.exports = __webpack_public_path__ + "img/section4-parallax6.7405da19.png";